import * as React from "react";

function SvgRetina(props, ref) {
  return (
    <svg
      id="Retina_svg__Retina_Logos"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 100 100"
      xmlSpace="preserve"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <style>{".Retina_svg__st1{fill:#bd10e0}"}</style>
      <switch>
        <g>
          <path
            className="Retina_svg__st1"
            d="M66.4 38.9c1.7 0 3.1-1.4 3.1-3.1 0-1.7-1.4-3.1-3.1-3.1-1.7 0-3 1.3-3.1 3l-24.5 6.6c-.9-1.4-2.8-1.9-4.2-1s-1.9 2.8-1 4.2c.3.5.8 1 1.4 1.2.4.2.8.3 1.2.3 1.2 0 2.3-.7 2.8-1.8.2-.4.2-.8.3-1.2l24.6-6.6c0 .1.1.2.1.2l-14.4 19c-.3-.1-.7-.2-1.1-.2-1.7 0-3.1 1.4-3.1 3.1s1.4 3.1 3.1 3.1c1 0 1.9-.5 2.5-1.3l12.2 4.2v.1c0 1.7 1.4 3.1 3.1 3.1 1.7 0 3.1-1.4 3.1-3.1 0-1.7-1.4-3.1-3.1-3.1-1 0-1.9.5-2.5 1.3l-12.2-4.1v-.1c0-.7-.2-1.3-.6-1.8l14.4-19c.2.1.6.1 1 .1zM49.8 59.6c0 .8-.6 1.3-1.3 1.3-.7 0-1.3-.6-1.3-1.3s.6-1.3 1.3-1.3c.2 0 .3 0 .5.1s.4.2.6.4c.1.2.2.5.2.8zm16.1-22.5c-.2-.1-.4-.2-.6-.4l-.1-.1c-.1-.2-.2-.5-.2-.7.1-.7.7-1.3 1.4-1.2.6.1 1.2.6 1.2 1.2 0 .7-.6 1.3-1.3 1.4-.1-.1-.2-.1-.4-.2zm-29.7 5.5c.2 0 .4 0 .5.1.2.1.5.3.6.5.1.2.2.5.2.7 0 .2 0 .3-.1.5-.1.3-.4.6-.7.7-.7.2-1.4-.2-1.7-.9-.1-.3-.1-.6 0-.9.2-.3.7-.6 1.2-.7zm28.7 23c0-.7.6-1.3 1.3-1.3.7 0 1.3.6 1.3 1.3 0 .7-.6 1.3-1.3 1.3s-1.3-.5-1.3-1.3z"
          />
          <path
            className="Retina_svg__st1"
            d="M81.6 30.2c-10.9-15.3-32.2-18.8-47.4-7.9s-18.8 32.2-7.9 47.4c5.3 7.4 13.2 12.3 22.2 13.8 1.8.3 3.7.5 5.5.5 18.8 0 34-15.3 34-34-.1-7.1-2.3-14-6.4-19.8zm4.2 25c-2.9 17.6-19.5 29.5-37 26.6s-29.5-19.5-26.6-37c2.9-17.6 19.5-29.5 37-26.6 8.4 1.4 16 6.1 21 13 5 7 7 15.6 5.6 24z"
          />
        </g>
      </switch>
    </svg>
  );
}

export default React.forwardRef(SvgRetina);
